import 'normalize.css';
// import 'react-table/react-table.css';
import './assets/styles/base.css';/*
import '../node_modules/react-md/src/scss/_react-md.scss'; */
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import createHistory from 'history/createBrowserHistory';

import { i18nSetup } from './i18n';
import { flattenMessages } from './scripts/utils/index';
import messages from './scripts/utils/messages';
import registerServiceWorker from './scripts/registerServiceWorker';
import configRouter from './scripts/router';
import configureStore from './scripts/store/configureStore';


const history = createHistory();
const { store, persistor } = configureStore(history);
const Router = configRouter(history);

addLocaleData([...en, ...es]);

const locale = (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage
  || 'es-MX';

i18nSetup(locale);

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={locale} messages={flattenMessages(messages[locale] || messages['en-US'])}>
      <PersistGate loading={null} persistor={persistor}>
        <Router />
      </PersistGate>
    </IntlProvider>
  </Provider>,
  document.getElementById('root') || document.createElement('div'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx